import React, { Fragment, useState,useEffect } from "react";
import Call from "../../../hocs/call";
import {
  changeCubeListCubeOwnershipOwners,
  hideCubeListCubeOwnership,
  hideCubeListCurrentDataView,
  readCubeListCubeOwnershipOwnersRead,
  readCubeListCubeOwnershipUsersRead,
  readCubeListCubes,
  readCubeListCurrentDataView,
  removeCubeListCubeEmbargo,
  showCubeListCubeDownload,
  showCubeListCubeOwnership,
  showCubeListCurrentDataView,
  submitCubeListCubeOwnership,
  submitCubeListDeleteCube,
  submitCubeListEmptyCube,
  submitCubeListUpdateCube,
  deleteRecordsFromCubeDataListTable,
  showObsValueUpdateModal,
  hideObsValueUpdateModal,
  submitCubeDetailObsValueUpdate,
  showObsValueCodeListModal,
  hideObsValueCodeListModal,
  readCubeObsValueCodeList,
  setItemFromObsCodeList,
  modeCubeListDelete,
} from "./actions";
import { translate } from "react-i18next";
import {
  MARGIN_LG,
  MARGIN_MD,
  MODAL_WIDTH_LG,
  MODAL_WIDTH_SM,
  SPAN_FULL,
  SPAN_ONE_QUARTER,
  SPAN_THREE_QUARTERS,
  TABLE_COL_MIN_WIDTH_ID,
  TABLE_COL_MIN_WIDTH_NAME,
} from "../../../styles/constants";
import { connect } from "react-redux";
import { compose } from "redux";
import EnhancedModal from "../../../components/enhanced-modal";
import Selector from "../../../components/selector";
import PerfInput from "../../../components/perf-input";
import { DataLanguageConsumer } from "../../../contexts/DataLanguage";
import ItemList from "../../../components/item-list"
import CubeDownload, { DELETEMODE, DOWNLOADMODE } from "./CubeDownload";
import { Button, Col, Form, Icon, Input, Modal, Row } from "antd";
import { getFilterObjFromViewerObj } from "../../../utils/filter";
import {
  BUTTON_DELETE,
  BUTTON_DETAIL,
  BUTTON_DOWNLOAD,
  BUTTON_EMPTY_CUBE,
  BUTTON_INFO,
  BUTTON_MANAGE_OWNERS,
  BUTTON_REMOVE_EMBARGO,
  BUTTON_REFRESH_LAST_UPDATE,
  BUTTON_EDIT
} from "../../../styles/buttons";
import ArtefactOwnershipModal from "../../../components/artefact-ownership-modal";
import InfiniteScrollTable from "../../../components/infinite-scroll-table";
import InfiniteScrollDataTable from "../../../components/infinite-scroll-data-table";
import moment from "moment";
import "./style.css";
import { isNumeric } from "../../../utils/form";
  
const dateFormat = "DD/MM/YYYY, HH:mm:ss";

const mapStateToProps = (state) => ({
  appLanguage: state.app.language,
  cubes: state.scenes.dataManager.cubeList.cubes,
  cubeId: state.scenes.dataManager.cubeList.cubeId,
  currentDataView: state.scenes.dataManager.cubeList.currentDataView,
  isCubeDetailVisible: state.scenes.dataManager.cubeList.isCubeDetailVisible,
  isCubeDownloadVisible:
    state.scenes.dataManager.cubeList.isCubeDownloadVisible,
  cubeOwnershipCubeId: state.scenes.dataManager.cubeList.cubeOwnershipCubeId,
  permissions: state.app.user.permissions,
  cubeOwnershipUsers: state.scenes.dataManager.cubeList.cubeOwnershipUsers,
  cubeOwnershipOwners: state.scenes.dataManager.cubeList.cubeOwnershipOwners,
  isObsValueModalVisible: state.scenes.dataManager.cubeList.isObsValueModalVisible,
  obsValue: state.scenes.dataManager.cubeList.obsValue,
  isObsCodeListModalVisible: state.scenes.dataManager.cubeList.isObsCodeListModalVisible,
  isObsValueCoded: state.scenes.dataManager.cubeList.isObsValueCoded,
  obsCodeList: state.scenes.dataManager.cubeList.obsCodeList,
  itemCount: state.scenes.dataManager.cubeList.itemCount,
  isAlphanumeric: state.scenes.dataManager.cubeList.isAlphanumeric
});

const formItemLayout = {
  labelCol: { span: SPAN_ONE_QUARTER },
  wrapperCol: { span: SPAN_THREE_QUARTERS },
};

const mapDispatchToProps = (dispatch) => ({
  onCurrentDataViewShow: (cubeId,dsdId) =>
    dispatch(showCubeListCurrentDataView(cubeId,dsdId)),
  onCurrentDataViewHide: () => dispatch(hideCubeListCurrentDataView()),
  fetchCubes: () => dispatch(readCubeListCubes()),
  fetchCurrentDataView: (
    cubeId,
    pageNum,
    pageSize,
    filterTable,
    sortCols,
    sortByDesc
  ) =>
    dispatch(
      readCubeListCurrentDataView(
        cubeId,
        pageNum,
        pageSize,
        filterTable,
        sortCols,
        sortByDesc
      )
    ),
  onCubeDownloadShow: (cubeId) => dispatch(showCubeListCubeDownload(cubeId)),
  onCubeEmbargoRemove: (cubeId) => dispatch(removeCubeListCubeEmbargo(cubeId)),
  onCubeOwnershipShow: (cubeId) => dispatch(showCubeListCubeOwnership(cubeId)),
  onCubeOwnershipHide: () => dispatch(hideCubeListCubeOwnership()),
  fetchOwnershipUsers: () => dispatch(readCubeListCubeOwnershipUsersRead()),
  fetchOwnershipOwners: (cubeCode) =>
    dispatch(readCubeListCubeOwnershipOwnersRead(cubeCode)),
  onCubeOwnershipOwnersChange: (owners) =>
    dispatch(changeCubeListCubeOwnershipOwners(owners)),
  onCubeOwnershipSubmit: (cubeCode, owners) =>
    dispatch(submitCubeListCubeOwnership(cubeCode, owners)),
  onEmptyCube: (cubeId) => dispatch(submitCubeListEmptyCube(cubeId)),
  onDeleteCube: (cubeId) => dispatch(submitCubeListDeleteCube(cubeId)),
  onUpdateCube: (cubeId) => dispatch(submitCubeListUpdateCube(cubeId)),
  onDeleteCubeRecords: (cubeId,selectedRecords) => dispatch(deleteRecordsFromCubeDataListTable(cubeId,selectedRecords)),
  onObsValueChangeShow: (obsValue,sid,timePeriod) => dispatch(showObsValueUpdateModal(obsValue,sid,timePeriod)),
  onObsValueChangeHide: () => dispatch(hideObsValueUpdateModal()),
  onObsValueUpdateSubmit: (cubeId,newObsValue,recordId) => dispatch(submitCubeDetailObsValueUpdate(cubeId,newObsValue,recordId)),
  onObsCodeListModalShow : () => dispatch(showObsValueCodeListModal()),
  onObsCodeListModalHide : () => dispatch(hideObsValueCodeListModal()),
  fetchCodeList: (codelistTriplet,dataLanguage,pageNum,pageSize,searchText,filters,sortCol,sortByDesc) => dispatch(readCubeObsValueCodeList(codelistTriplet,dataLanguage,pageNum,pageSize,searchText,filters,sortCol,sortByDesc)),
  onCodeListItemSet: () => dispatch(setItemFromObsCodeList()),
  onModeCubeListDelete: (value) => dispatch(modeCubeListDelete(value))
});

const CubeList = ({
  appLanguage,
  t,
  cubes,
  cubeId,
  permissions,
  currentDataView,
  onCurrentDataViewShow,
  onCurrentDataViewHide,
  fetchCubes,
  fetchCurrentDataView,
  isCubeDetailVisible,
  onCubeDownloadShow,
  onCubeEmbargoRemove,
  onCubeOwnershipShow,
  onCubeOwnershipHide,
  cubeOwnershipCubeId,
  cubeOwnershipUsers,
  cubeOwnershipOwners,
  fetchOwnershipUsers,
  fetchOwnershipOwners,
  onCubeOwnershipOwnersChange,
  onCubeOwnershipSubmit,
  onEmptyCube,
  onDeleteCube,
  onUpdateCube,
  onDeleteCubeRecords,
  isObsValueModalVisible,
  onObsValueChangeShow,
  onObsValueChangeHide,
  obsValue,
  onObsValueUpdateSubmit,
  isObsCodeListModalVisible,
  onObsCodeListModalShow,
  onObsCodeListModalHide,
  isObsValueCoded,
  obsCodeList,
  itemCount,
  fetchCodeList,
  onCodeListItemSet,
  isAlphanumeric,
  onModeCubeListDelete
}) => {

  const [selectedRecords,setSelectedRecords] = useState([]);
  const [newObsValue,setNewObsValue] = useState(null)
  useEffect(()=>{setNewObsValue(obsValue)},[obsValue])
  const cubeCode = cubes && cubeId ? cubes.find(({ IDCube }) => IDCube === cubeId).Code : ""

  return(
  <Fragment>    
    <EnhancedModal
      visible={cubeId !== null && isCubeDetailVisible}
      title={t("scenes.dataManager.cubeList.currentDataViewModal.title", {
        id: cubeCode,
      })}
      width={MODAL_WIDTH_LG}
      onCancel={()=> {onCurrentDataViewHide();setSelectedRecords([])}}
      footer={
        <Button onClick={onCurrentDataViewHide}>
          {t("commons.buttons.close.title")}
        </Button>
      }
    >
    <div className="cubelist_data__table" >
      <InfiniteScrollDataTable
        data={currentDataView && currentDataView.Data}
        cols={currentDataView && currentDataView.Columns}
        rowTotal={currentDataView && currentDataView.Count}
        hiddenCols={["SID","InsertDate"]}
        onChange={({
          pageNum,
          pageSize,
          searchText,
          filters,
          sortCol,
          sortByDesc,
        }) =>
          fetchCurrentDataView(
            cubeId,
            pageNum,
            pageSize,
            getFilterObjFromViewerObj(
              currentDataView &&
                currentDataView.Columns.filter((colName) => colName !== "SID"),
              searchText,
              filters
            ),
            sortCol ? [sortCol] : null,
            sortByDesc
          )
        }
        getRowKey ={({SID:sid,ID_TIME_PERIOD:timePeriod})=>(sid+"___"+timePeriod)}
        rowSelection={{
          selectedRowKeys: selectedRecords,
          onSelect: (recordId, selected) =>
            selected
              ? setSelectedRecords([...selectedRecords, recordId])
              : setSelectedRecords(selectedRecords.filter(el => el !== recordId))
        }}
        tableActions={[{
          icon: "delete",
          title: t('commons.actions.delete.title'),
          hasRectangularButton: true,
          onClick: () => {
            Modal.confirm({
              title: t('scenes.dataManager.cubeList.modals.confirms.removeRecords.title',{numRecords:selectedRecords.length,id: cubeCode}),
              onOk() {
                onDeleteCubeRecords(cubeId, selectedRecords)
                setSelectedRecords([])
              },
              cancelText: t('commons.buttons.cancel.title')
            })
          }
        }]}
        actions={[
          {
            ...BUTTON_DELETE,
            title: t("commons.actions.delete.title"),
            onClick: (record) =>
              Modal.confirm({
                title: t('scenes.dataManager.cubeList.modals.confirms.removeRecord.title', {id: cubeCode}),
                onOk() {
                  onDeleteCubeRecords(cubeId, [record.SID + "___" + record.ID_TIME_PERIOD])
                },
                cancelText: t("commons.buttons.cancel.title"),
              }),
          }
        ]}
        colActions={[
          {
            ...BUTTON_EDIT,
            title: t("scenes.dataManager.cubeList.actions.updateObsValue.title"),
            onClick: ({OBS_VALUE: obsValue, SID: sid, ID_TIME_PERIOD: timePeriod}) => {
              onObsValueChangeShow(obsValue, sid, timePeriod)
            },
            dataIndex: "OBS_VALUE"
          }
        ]}
      />
      </div>
    </EnhancedModal>
    <Call cb={fetchCubes} disabled={cubes !== null}>
      <InfiniteScrollTable
        data={
          cubes
            ? cubes.map((cube) => ({
                ...cube,
                view: `Dataset_${cube.IDCube}_ViewCurrentData`,
                fact: `FactS${cube.IDCube}`,
                filter: `FiltS${cube.IDCube}`,
              }))
            : null
        }
        getRowKey={(cube) => cube.Code}
        multilangStrDataIndexes={["labels"]}
        columns={[
          {
            title: t("data.cube.id.label"),
            dataIndex: "Code",
            minWidth: TABLE_COL_MIN_WIDTH_ID,
          },
          {
            title: t("data.cube.name.label"),
            dataIndex: "labels",
            minWidth: TABLE_COL_MIN_WIDTH_NAME,
          },
          {
            title: t("data.cube.dsd.label"),
            dataIndex: "DSDCode",
            minWidth: 150,
          },
          {
            title: t("data.cube.lastUpdate.label"),
            dataIndex: "LastUpdate",
            widthToContent: true,
            render: (dateTime) => moment(dateTime).format(dateFormat),
            renderText: (dateTime) => moment(dateTime).format(dateFormat),
            sorter: (dateStrA, dateStrB) =>
              moment(dateStrA, dateFormat).diff(moment(dateStrB, dateFormat)),
          },
          {
            title: t("data.cube.hasEmbargoedData.shortLabel"),
            dataIndex: "HasEmbargoedData",
            width: 30,
            withValuesFilter: true,
            render: (HasEmbargoedData) =>
              HasEmbargoedData ? <Icon type="check" /> : null,
            renderText: (HasEmbargoedData) =>
              HasEmbargoedData
                ? t("data.dataflow.hasEmbargoedData.values.true")
                : t("data.dataflow.hasEmbargoedData.values.false"),
          },
        ]}
        actions={[
          {
            ...BUTTON_DETAIL,
            title: t("scenes.dataManager.cubeList.actions.detail.title"),
            onClick: ({IDCube,DSDCode}) => onCurrentDataViewShow(IDCube,DSDCode),
          },
          {
            ...BUTTON_INFO,
            title: t("scenes.dataManager.cubeList.actions.info"),
            onClick: ({ view, fact, filter, Code }) =>
              Modal.info({
                title: t("scenes.dataManager.cubeList.modals.info.title", {id: Code,}),
                content: (
                  <Form>
                    <Row style={{ marginTop: MARGIN_LG }}>
                      <Col span={SPAN_FULL}>
                        <Form.Item
                          label={t("scenes.dataManager.cubeList.modals.info.view.title")}
                          {...formItemLayout}
                        >
                          <Input value={view} title={view} disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: MARGIN_MD }}>
                      <Col span={SPAN_FULL}>
                        <Form.Item
                          label={t("scenes.dataManager.cubeList.modals.info.fact.title")}{...formItemLayout}
                        >
                          <Input value={fact} title={fact} disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: MARGIN_MD }}>
                      <Col span={SPAN_FULL}>
                        <Form.Item
                          label={t(
                            "scenes.dataManager.cubeList.modals.info.filter.title")}{...formItemLayout}
                        >
                          <Input value={filter} title={filter} disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                ),
              }),
          },
          {
            ...BUTTON_DOWNLOAD,
            title: t("scenes.dataManager.cubeList.actions.download.title"),
            onClick: ({ IDCube }) => {
                onCubeDownloadShow(IDCube)
                onModeCubeListDelete(false)
              },
          },
          ({ HasEmbargoedData }) =>
            HasEmbargoedData
              ? {
                  ...BUTTON_REMOVE_EMBARGO,
                  title: t("scenes.dataManager.cubeList.actions.removeEmbargo.title"),
                  onClick: ({ IDCube, Code }) =>
                    Modal.confirm({
                      title: t("scenes.dataManager.cubeList.modals.confirms.removeEmbargo.title",{ id: Code } ),
                      onOk() {
                        onCubeEmbargoRemove(IDCube);
                      },
                      cancelText: t("commons.buttons.cancel.title"),
                    }),
                }
              : null,
          ({ Code }) =>
            permissions.cubeOwner.includes(Code)
              ? {
                  ...BUTTON_MANAGE_OWNERS,
                  title: t("commons.actions.manageOwners.title"),
                  onClick: (cube) => onCubeOwnershipShow(cube.Code),
                }
              : null,
          {
            ...BUTTON_EMPTY_CUBE,
            title: t("commons.actions.emptyCube.title"),
            onClick: ({ IDCube, Code }) =>
              Modal.confirm({
                title: t(
                  "scenes.dataManager.cubeList.modals.confirms.emptyCube.title",
                  { id: Code }
                ),
                onOk() {
                  onEmptyCube(IDCube);
                },
                cancelText: t("commons.buttons.cancel.title"),
              }),
          },
          {
            ...BUTTON_REFRESH_LAST_UPDATE,
            title: t("commons.actions.update.title"),
            onClick: ({ IDCube, Code}) => {
              Modal.confirm({
                title: t(
                  "scenes.dataManager.cubeList.modals.confirms.update.title",
                  { id: Code }
                ),
                onOk() {
                  onUpdateCube(IDCube);
                },
                cancelText: t("commons.buttons.cancel.title"),
              });
            },
          },
          {
            ...BUTTON_DELETE,
            title: t("commons.actions.delete.title"),
            onClick: ({ IDCube, Code }) =>
              Modal.confirm({
                title: t(
                  "scenes.dataManager.cubeList.modals.confirms.delete.title",
                  { id: Code }
                ),
                onOk() {
                  onDeleteCube(IDCube);
                },
                cancelText: t("commons.buttons.cancel.title"),
              }),
          },
          {
            className: "button-color-red",
            title:"filtered deletion",
            icon:"filter",
            onClick: ({ IDCube }) => {
              onCubeDownloadShow(IDCube)
              onModeCubeListDelete(true)
            },
          }
        ]}
      />
    </Call>
    <CubeDownload  />
    <ArtefactOwnershipModal
      isVisible={cubeOwnershipCubeId !== null}
      id={cubeOwnershipCubeId}
      onClose={onCubeOwnershipHide}
      users={cubeOwnershipUsers}
      owners={cubeOwnershipOwners}
      fetchUsers={fetchOwnershipUsers}
      fetchOwners={() => fetchOwnershipOwners(cubeOwnershipCubeId)}
      onOwnersChange={onCubeOwnershipOwnersChange}
      onSubmit={() =>
        onCubeOwnershipSubmit(cubeOwnershipCubeId, cubeOwnershipOwners)
      }
    />
     <EnhancedModal
              visible={isObsValueModalVisible ? true : false}
              onCancel={onObsValueChangeHide}
              title={t('scenes.dataManager.cubeList.modals.updateObsValue.title')}
              width={MODAL_WIDTH_SM}
              footer={<div>
                <Button
                type="primary"
                onClick={() => {
                if(!isObsValueCoded){
                  if ((newObsValue === "" || isNumeric(newObsValue)) || isAlphanumeric)
                  onObsValueUpdateSubmit(cubeId,newObsValue,isObsValueModalVisible)}
                else
                  onObsValueUpdateSubmit(cubeId,newObsValue,isObsValueModalVisible)

                }}>{t("commons.buttons.save.title")}</Button> 
                <Button
                onClick={onObsValueChangeHide}>{t('commons.buttons.close.title')}</Button>
              </div>}
            > 
            <Form>        
                <Row >
                  <Col span={SPAN_FULL}>
                    <Form.Item
                      label={'OBS_VALUE'}
                      validateStatus={(!isObsValueCoded && !isAlphanumeric && newObsValue !== null && !(newObsValue === "" || isNumeric(newObsValue))) ? ('warning') : (null)}
                      help={(!isObsValueCoded && !isAlphanumeric && newObsValue !== null && !(newObsValue === "" || isNumeric(newObsValue))) ? (t('commons.alerts.numericOnly.label')) : (null)}
                      {...formItemLayout}
                    >
                      {isObsValueCoded ?
                      (
                        <Selector 
                        selectTitle={t('scenes.dataManager.cubeList.buttons.select.title')}
                        resetTitle={t('scenes.dataManager.cubeList.buttons.reset.title')}
                        onSelect={onObsCodeListModalShow}
                        onReset={()=> {setNewObsValue(null)}}
                        onDetail={null}
                        value={newObsValue}
                      />)
                    :
                    (<PerfInput Component={Input} onChange={setNewObsValue} value={newObsValue} title={'OBS_VALUE'}  />)
                    }
                    </Form.Item>
                  </Col>
                </Row>
            </Form>
          </EnhancedModal>

          <EnhancedModal
            visible={isObsCodeListModalVisible ? isObsCodeListModalVisible : false}
            onCancel={onObsCodeListModalHide}
            title={t('scenes.dataManager.cubeList.modals.obsCodeList.title')}
            width={MODAL_WIDTH_LG}
            footer={<Button onClick={onObsCodeListModalHide}> {t("commons.buttons.close.title")} </Button>}
           >
            <DataLanguageConsumer>
              {(dataLanguage) => {
                const itemListLang = dataLanguage || appLanguage;
                return (
                  <ItemList
                    data={obsCodeList ? obsCodeList : null}
                    rowCount={itemCount}
                    isPaginated
                    onRowClick={(item) =>{onCodeListItemSet(); setNewObsValue(item.id)}}
                    onChange={({ pageNum, pageSize, searchText, filters, sortCol, sortByDesc }) =>
                    fetchCodeList(isObsValueCoded, itemListLang, pageNum, pageSize, searchText, filters, sortCol, sortByDesc)}
                  />
                )
              }}
            </DataLanguageConsumer>
          </EnhancedModal>
  </Fragment>)
};

export default compose(
  translate(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CubeList);
